import React, { useEffect, useRef } from 'react';
import './TransformSection.css';
import {Link} from 'react-router-dom';

const transformCards = [
  {
    icon: '/icons/tech.webp',
    title: 'tech adoption',
    desc: 'Embracing cutting-edge technologies such as artificial intelligence, machine learning, productization and cloud computing to drive operational efficiency and improve decision-making.',
  },
  {
    icon: '/icons/optimization.webp',
    title: 'Process optimisation',
    desc: 'Reengineering and streamlining existing processes to leverage digital tools and automation, eliminating, improving agility, and accelerating time-to-market.',
  },
  {
    icon: '/icons/shift.webp',
    title: 'Cultural shift',
    desc: 'Encouraging a mindset of innovation, collaboration, and continuous learning throughout the organisation to foster adaptability, agility, and a customer-centric approach..',
  },
  {
    icon: '/icons/customer.webp',
    title: 'Customer experience enhancement',
    desc: 'Leveraging digital channels and data-driven insights to personalise and enhance customer experiences‍.',
  },
];

const TransformSection = () => {
  const headingRef = useRef(null);
  const paraTopRef = useRef(null);
  const paraRightRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    [headingRef.current, paraTopRef.current, paraRightRef.current, ...cardRefs.current].forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="transform-section" id ="components">
      <div className="container">
      <div className="transform-header">
        <h2 ref={headingRef}>
          KEY TRANSFORMATION <span className="blue"> COMPONENTS</span>
        </h2>
        <p className="para-right" ref={paraRightRef}>
          Embrace the era of digital transformation by productizing your offer. While competitors move faster than ever, we make you leap ahead.
        </p>
      </div>

      <p className="para-below" ref={paraTopRef}>
        We understand that your users expect top-notch digital experiences, so we deliver the next big thing.
We help your scale-up or enterprise build resilience and unlock the true potential of new digital technologies.
      </p>

      <div className="transform-cards">
        {transformCards.map((card, idx) => (
          <div
            key={idx}
            className="transform-card fade-up"
            ref={el => cardRefs.current[idx] = el}
          >
            <img src={card.icon} alt="icon" className="transform-icon" />
            <h3 className="transform-title">{card.title}</h3>
            <p className="transform-desc">{card.desc}</p>
          </div>
        ))}
      </div>

      <div className="transform-button-wrapper">
        <Link to="/contact">
  <button className="transform-button">
    GET STARTED WITH YOUR DIGITAL TRANSFORMATION PROJECT
  </button>
</Link>
      </div>
      </div>
    </section>
  );
};

export default TransformSection;
